import React     from 'react';
import PropTypes from 'prop-types';
import {
  branch,
  compose,
  mapProps,
  renderNothing,
  setDisplayName,
}                from 'recompose';
import _         from 'underscore';
import 'load-awesome/css/ball-square-clockwise-spin.min.css';


export const LA_TYPES = {
  BALL_SQUARE_CLOCKWISE_SPIN: 'ball-square-clockwise-spin',
};


const LA_DIV_COUNTS_BY_TYPE = {
  [LA_TYPES.BALL_SQUARE_CLOCKWISE_SPIN]: 8,
};


const LoadingPresentation = ({type, styles, dotCount}) => <div className="Loading" style={styles.Loading}>

  <div className={`spinner la-${type}`} style={styles.spinner}>
    {_.range(0, dotCount).map((index) => <div style={styles.dot} key={index}/>)}
  </div>

</div>;


LoadingPresentation.propTypes = {

  // The styles for the elements.
  styles: PropTypes.shape({
    Loading: PropTypes.object.isRequired,
    spinner: PropTypes.object.isRequired,
    dot:     PropTypes.object.isRequired,
  }).isRequired,

  // The number of dots to display.
  dotCount: PropTypes.number.isRequired,

};


// noinspection JSSuspiciousNameCombination
const Loading = compose(
  setDisplayName('Loading'),
  branch(
    props => false === props.when,
    renderNothing,
  ),
  mapProps(({type, height}) => {

    // noinspection JSSuspiciousNameCombination
    const width = height;

    return {
      type,
      styles:   {
        Loading: {
          position:        'absolute',
          top:             0,
          left:            0,
          right:           0,
          bottom:          0,
          minHeight:       '100px',
          backgroundColor: '#fff',
          opacity:         0.5,
          zIndex:          999,
        },
        spinner: {
          position: 'absolute',
          top:      `calc(50% - (${height} / 2))`,
          left:     `calc(50% - (${width} / 2))`,
          height,
          width,
          color:    '#0c5460',
        },
        dot:     {
          width:  `calc(${width / 2.5}`,
          height: `calc(${height / 2.5}`,
        },
      },
      dotCount: LA_DIV_COUNTS_BY_TYPE[type],
    };

  })
)(LoadingPresentation);


Loading.propTypes = {

  // Type of spinner to display.
  // When adding additional allowed types, you need to also include the CSS file above.
  type: PropTypes.oneOf([LA_TYPES.BALL_SQUARE_CLOCKWISE_SPIN]),

  // Height (& width) of the component.
  height: PropTypes.string,

  // Flag to indicating whether to display the Loading component.
  // If not provided, the component will be displayed.
  when: PropTypes.bool,

};


Loading.defaultProps = {
  type:   LA_TYPES.BALL_SQUARE_CLOCKWISE_SPIN,
  height: '30px',
  // Display the component if loading is not specifically set to false.
  // This allows the component to be rendered without specifying when.
  when:   true,
};


export default Loading;

export { Loading };


// WEBPACK FOOTER //
// ./src/components/generic/Loading.js